import { selectPolicies } from '@v2/domains/user/selectors/user.selectors'

import { useAppSelector } from 'src/v2/store/hooks'

import { RouteKey } from '../types/routing.types'
import { getRequiredPolicy, hasRoutePermission } from '../utils/route.utils'

export const useRoutePermissions = () => {
  const userPolicies = useAppSelector(selectPolicies)

  const canAccess = (routeKey: RouteKey): boolean => {
    return hasRoutePermission(routeKey, userPolicies)
  }

  const getRoutePolicy = (routeKey: RouteKey): string | null => {
    return getRequiredPolicy(routeKey)
  }

  const hasPolicy = (policy: string): boolean => {
    return userPolicies.includes(policy)
  }

  return {
    canAccess,
    getRoutePolicy,
    hasPolicy,
    userPolicies,
  }
}
